document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#compra-por-tienda"], a[href="/#compra-por-tienda"]');
  if (!link) return;
  const target = document.getElementById('compra-por-tienda');
  if (!target) return;
  event.preventDefault();
  target.setAttribute('tabindex', '-1');
  target.focus({preventScroll: true});
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
});
